export default __webpack_public_path__ + "static/media/ajibadePic.02519943.jpg";